export interface ResourceClient {
  call(options: any): Promise<any>;
  get(options: any): Promise<any>;
  post(options: any): Promise<any>;
  put(options: any): Promise<any>;
  delete(options: any): Promise<any>;

  url(path: string, base?: string): string;
  urlFromPath(path: string, base?: string): string;

  readonly token: string;
  readonly base: string;
  readonly config: any;
}

export default abstract class Resource {
  private readonly clientProvider: () => ResourceClient;

  abstract get resourceName(): string;
  abstract get resourcesName(): string;

  constructor(clientProvider: () => ResourceClient) {
    if (typeof clientProvider !== 'function') {
      throw new Error(
        `[Resource] Invalid client provider: expected a function but got ${typeof clientProvider}`
      );
    }
    this.clientProvider = clientProvider;
  }

  protected get client(): ResourceClient {
    return this.clientProvider();
  }

  call(options) {
    return this.client.call(options);
  }

  modifier(name, format = 'json') {
    return `${name}.${format}`;
  }

  collection(format = 'json') {
    return `${this.resourcesName}.${format}`;
  }

  collectionAction(name, format: string | null = 'json') {
    if (format != null) {
      return `${this.resourcesName}/${name}.${format}`;
    }
    return `${this.resourcesName}/${name}`;
  }

  member(id, format = 'json') {
    return `${this.resourcesName}/${id}.${format}`;
  }

  memberAction(id, action, format = 'json') {
    if (format != null) {
      return `${this.resourcesName}/${id}/${action}.${format}`;
    }

    return `${this.resourcesName}/${id}/${action}`;
  }

  attributesForObject(object) {
    const attributes = {};
    if (this.resourceName) {
      attributes[this.resourceName] = object;
    }
    return attributes;
  }
}
